<template>
  <div class="tabela-empresas">
    <Paginacao produtos :conteudo="conteudo" @pagina="p => (produtosPaginados = p)">
      <TabelaPadrao
        templateColumns="1fr 2fr 1fr 2fr 3fr 2fr 2fr 2fr 2fr"
        acao="100px"
        selecao="50px"
        :conteudoPaginado="produtosPaginados"
        :conteudoTotal="conteudo"
        :estruturaTabela="estruturaTabela"
        :deleteTabela="deleteTabela"
        :editTabela="editTabela"
        :alertaAmareloClick="alertaAmareloClick"
        :alertaVermelhoClick="alertaVermelhoClick"
        alertaAmarelo="A NCM do produto não possui vínculo com as CNAEs da Empresa"
        caminhoAlertaAmarelo="vinculo"
        alertaVermelho="Identificamos que o produto não se encontra mais vigente ou foi alterado, entretanto localizamos uma ou mais NCMs correlacionadas vigentes que podem substituir. <br>Clique aqui para selecionar uma nova NCM."
        caminhoAlertaVermelho="vigente"
        erro="Código do produto inexistente"
        caminhoErro="erro"
      />
    </Paginacao>
  </div>
</template>

<script>
import TabelaPadrao from "@/components/TabelaPadrao/TabelaPadrao.vue";
import Paginacao from "@/components/Paginacao/Paginacao.vue";
import filtros from "@/store/modules/cenarioFiltros.js";

export default {
  name: "TabelaProdutos",
  components: {
    TabelaPadrao,
    Paginacao
  },
  props: {
    conteudo: Array,
    alertaVermelhoClick: Function,
    alertaAmareloClick: Function,
    // alteraConteudo: Function,
    deleteTabela: Function,
    editTabela: Function,
    syncTabela: Function,
    cnaeTabela: Function
  },
  data() {
    return {
      filtros,
      produtosPaginados: [],
      estruturaTabela: [
        { nome: "CÓD", valor: "codigo_produto", alinhamento: "centro" },
        { nome: "NCM", valor: "ncm", alinhamento: "centro" },
        { nome: "EX", valor: "ex", alinhamento: "centro" },
        { nome: "CEST", valor: "cest", alinhamento: "centro" },
        { nome: "PRODUTO", valor: "nome" },
        { nome: "FABRICANTE", valor: "fabricante", alinhamento: "centro" },
        { nome: "MARCA", valor: "marca", alinhamento: "centro" },
        { nome: "EAN/GTIN", valor: "ean", alinhamento: "centro" },
        { nome: "DESTINAÇÃO", valor: "destinacao_label" }
      ],
      destinacaoOptions: [
        {
          value: "1",
          label: "00 - Mercadoria para Revenda"
        },
        {
          value: "2",
          label: "01 - Matéria-Prima"
        },
        {
          value: "3",
          label: "02 - Embalagem"
        },
        {
          value: "4",
          label: "03 - Produto em Processo"
        },
        {
          value: "5",
          label: "04 - Produto Acabado"
        },
        {
          value: "6",
          label: "05 - Subproduto"
        },
        {
          value: "7",
          label: "06 - Produto Intermediário"
        },
        {
          value: "8",
          label: "07 - Material de Uso e Consumo"
        },
        {
          value: "9",
          label: "08 - Ativo Imobilizado"
        },
        {
          value: "10",
          label: "09 - Serviços"
        },
        {
          value: "11",
          label: "10 - Outros insumos"
        },
        {
          value: "12",
          label: "99 - Outras"
        }
      ]
    };
  },
  created() {
    if (this.conteudo) {
      this.conteudo.forEach(e => {
        let destinacao = this.destinacaoOptions.find(f => f.value == e.id_destinacao);
        this.$set(e, "destinacao_label", destinacao ? destinacao.label : "");
        // if (e.ncm && e.ncm.length == 12) {
        //   this.$set(e, "vigente", 0);
        // }
        if (e.tipo == "incompleto") {
          this.$set(e, "erro", true);
        }
      });
    }
  },
  watch: {
    conteudo: {
      deep: true,
      handler() {
        if (this.conteudo) {
          this.conteudo.forEach(e => {
            let destinacao = this.destinacaoOptions.find(f => f.value == e.id_destinacao);
            this.$set(e, "destinacao_label", destinacao ? destinacao.label : "");
            this.$set(e, "cest", e.cest == 0 ? "-" : e.cest);
            this.$set(e, "ex", e.ex == 0 ? "-" : e.ex);
            // if (e.ncm && e.ncm.length == 12) {
            //   this.$set(e, "vigente", 0);
            // }
            if (e.tipo == "incompleto") {
              this.$set(e, "erro", true);
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tabela-empresas {
  width: 100%;
}
</style>
